import { ASSETS_IMAGE_BASE_PATH } from '@pai/commons'

import { Media, Portrait } from 'app/core/cms/generated/api-types'

/**
 * @returns https://assets.partneraid.ch/200x0/filters:quality(80):format(webp)/medias/demo-image.jpeg
 */
export function optimizedCmsImageUrl(
  assetsOrigin: string,
  img: Media | Portrait,
  width: number,
  height: number,
  quality: number,
  format: 'webp' | 'jpeg',
): string {
  const filters: Filter[] = [`quality(${quality})`, `format(${format})`]

  const imagePath = img.fullPath ?? 'no-path-available'

  // to generate a url with the original size, we skip the sizes part
  return cmsImageUrl(assetsOrigin, imagePath, [width, height], filters)
}

type TargetFormat = 'webp' | 'jpeg' | 'png'
type Filter = `quality(${number})` | `format(${TargetFormat})` | `focal(${number},${number})`

export function cmsImageUrl(
  assetsOrigin: string,
  imagePath: string,
  size: [width: number, height: number],
  filters?: Filter[] | null,
) {
  return [
    assetsOrigin,
    ASSETS_IMAGE_BASE_PATH,
    `${size[0]}x${size[1]}`,
    filters ? `filters:${filters.join(':')}` : null,
    imagePath,
  ]
    .filter(Boolean)
    .join('/')
}
